export default __webpack_public_path__ + "static/media/astrotools-io.5d7a389e.jpg";